import { render } from "./hris-managers.vue?vue&type=template&id=54e2fe82&lang=pug"
import script from "./hris-managers.vue?vue&type=script&setup=true&lang=js"
export * from "./hris-managers.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__